import { createBrowserHistory } from 'history'

const config = {}

const history = createBrowserHistory(config)

export default history
